const tournaments = {
    "LBL_PAGE_TITLE":"Турниры",
    "LBL_POPUP_ERROR":"Ошибка",
    "LBL_USERNAME_FORM_FIELD_NAME":"Создать имя пользователя:",
    "LBL_USERNAME_FORM_HELPER":"Вы входите в игровую зону впервые, вам необходимо создать логин",
    "LBL_USERNAME_FORM_FIELD":"Имя пользователя",
    "LBL_FORM_LOGIN_BUTTON":"Войти в игровую зону",
    "LBL_TYPE_BULLET":"Bullet",
    "LBL_TYPE_BLITZ":"Blitz",
    "LBL_TYPE_RAPID":"Rapid",
    "LBL_TYPE_CLASSIC":"Classic",
    "LBL_INITIAL_RATING":"Без ограничений"
};
export default tournaments;